<template>
  <app-layout>
    <div
      class="flex items-center justify-center h-full w-full"
      v-if="modalOpened"
    >
      <div
        class="h-full w-full flex flex-col items-center justify-between max-w-md"
      >
        <div class="mt-16 text-lg text-gray-500 font-bold">
          Choose a payment method
        </div>

        <div class="w-full mt-4">
          <button
            @click="doBuyWithStripe()"
            type="button"
            class="btn-purple text-white w-full"
            :disabled="loadingCheckout"
          >
            <i class="fas fa-credit-card mr-1" />
            Credit Card
          </button>

          <button
            @click="doBuyWithPaypalUsd()"
            type="button"
            class="btn-blue w-full mt-3"
            :disabled="loadingCheckout"
          >
            <i class="fab fa-paypal mr-1" /> PayPal
          </button>
        </div>

        <el-link
          class="text-xs mb-1 mt-2"
          @click="doBuyWithPaypalBrl()"
          :disabled="loadingCheckout"
        >
          Caso você seja
          <span class="text-green-500">brasileiro</span>,
          clique aqui para pagar em reais. O
          <span class="text-blue-500">PayPal</span>
          não aceita pagamento em dólares por brasileiros.
        </el-link>
      </div>

      <form
        ref="paypalUsdFormRef"
        :action="paypalFormAction"
        method="post"
        target="_top"
        class="hidden"
      >
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input
          type="hidden"
          name="hosted_button_id"
          :value="paypalCodeUsd"
        />
        <input
          type="hidden"
          name="invoice"
          :value="paypalInvoice"
        />
      </form>

      <form
        ref="paypalBrlFormRef"
        :action="paypalFormAction"
        method="post"
        target="_top"
        class="hidden"
      >
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input
          type="hidden"
          name="hosted_button_id"
          :value="paypalCodeBrl"
        />
        <input
          type="hidden"
          name="invoice"
          :value="paypalInvoice"
        />
      </form>
    </div>

    <app-activation-code-modal
      v-model="activationCodeModalOpened"
    />
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { v4 as uuid } from 'uuid';
import affiliates from '../util/affiliates';
import config from '../config';
import * as Sentry from '@sentry/browser';

export default {
  name: 'app-pricing',

  data() {
    return {
      modalOpened: false,
      activationCodeModalOpened: false,
      loadingCheckout: false,
    };
  },

  async created() {
    return this.signinOrOpenModal();
  },

  computed: {
    ...mapGetters({
      authenticatedAsync: 'auth/authenticatedAsync',
      premium: 'credits/premium',
      currentUser: 'auth/currentUser',
    }),

    paypalInvoice() {
      if (!this.currentUser) {
        return null;
      }

      return `premium.${
        this.currentUser.uid
      }.${uuid()}.${affiliates.get()}`;
    },

    paypalFormAction() {
      return `${config.PAYPAL_URL}/cgi-bin/webscr`;
    },

    paypalCodeBrl() {
      return config.PAYPAL_CODES.BRL;
    },

    paypalCodeUsd() {
      return config.PAYPAL_CODES.USD;
    },
  },

  methods: {
    async doBuyWithStripe() {
      if (this.loadingCheckout) {
        return;
      }

      try {
        this.loadingCheckout = true;

        const result = await window
          .Stripe(config.STRIPE_TOKEN)
          .redirectToCheckout({
            items: [
              { sku: config.STRIPE_SKU, quantity: 1 },
            ],
            successUrl: `${config.CLIENT_APP_URL}/purchase/success`,
            cancelUrl: `${config.CLIENT_APP_URL}/purchase/cancel`,
            customerEmail: this.currentUser.email,
            clientReferenceId: `${
              this.currentUser.uid
            }.${affiliates.get()}`,
          });

        this.loadingCheckout = false;

        if (result.error) {
          alert(result.error.message);
        }
      } catch (error) {
        Sentry.captureException(error);
        this.loadingCheckout = false;
      }
    },

    async doBuyWithPaypalUsd() {
      if (this.loadingCheckout) {
        return;
      }

      this.loadingCheckout = true;
      this.$refs.paypalUsdFormRef.submit();
    },

    async doBuyWithPaypalBrl() {
      if (this.loadingCheckout) {
        return;
      }

      this.loadingCheckout = true;
      this.$refs.paypalBrlFormRef.submit();
    },

    async signinOrOpenModal() {
      const authenticated = await this.authenticatedAsync();

      if (authenticated) {
        this.modalOpened = true;
        return;
      }

      this.$router.push('/auth/sign-in?referrer=/pricing');
    },
  },
};
</script>

<style></style>
